export enum AnswerType {
  Compliance = 'COMPLIANCE',
  Numeric = 'NUMERIC',
  Text = 'TEXT',
  OptionSelection = 'OPTION_SELECTION',
}

export const answerTypes = Object.values(AnswerType);

export function isAnswerType(value: unknown): value is AnswerType {
  return typeof value === 'string' && answerTypes.includes(value as AnswerType);
}
